export enum ContainerEnums {
    landing = 'landing',
    allProducts = 'all-products',
    shoppingBag = 'shopping-bag'
}